// ### Imports
// * Import lib
import React from "react";

// * Import 3rd party lib
import { CircularProgress, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";

// * Import kits
import Box from "../../../kit/Box";
// import Box from "../../kit/Box";
import Typography from "../../../kit/Typography";
import { Button } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import errorImageLight from "../../../../assets/images/No_Data.svg";
import errorImageDark from "../../../../assets/images/dark_theme/No_data_dark.svg";
import LoadingImageLight from "../../../../assets/images/LoadingImage.svg";
import LoadingImageDark from "../../../../assets/images/dark_theme/LoadingImageDark.svg";
import { useSelector } from "react-redux";
import { getThemeName } from "../../../utils/utils";
import { useStyles } from "../../../theme/style";
import { useNavigate } from "react-router-dom";

export function Error({
  message = "No data found!",
  imageHeight,
  height = "100%",
  retryFunction = () => {},
}) {
  const theme = useTheme();
  const isDarkMode = useSelector((state) => state.selections.isDarkMode);
  const errorImage = getThemeName(isDarkMode)
    ? errorImageDark
    : errorImageLight;

  const classes = useStyles(theme);
  const navigate = useNavigate();
  return (
    <Box
      style={{
        height: height,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        style={{
          maxHeight: imageHeight,
          width: "100%",
          marginBottom: theme.size[10],
        }}
        src={errorImage}
        alt="error"
      />
      {message && (
        <Typography
          sx={{
            textAlign: "center",
            margin: theme.margin[1],
            fontSize: theme.size[13],
            fontWeight: theme.fontWeight[500],
            color: theme.palette.cards.heading,
          }}
        >
          {message}
        </Typography>
      )}

      <Button
        disableRipple
        className={classes.outlinedButton}
        onClick={() => {
          retryFunction();
        }}
        style={{
          fontWeight: theme.fontWeight[500],
          width: "130px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ReplayIcon
            sx={{ fontSize: theme.size[18], marginRight: theme.size[4] }}
          />
          <span>Retry</span>
        </div>
      </Button>
    </Box>
  );
}

export default Error;
